import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import alumnisocialcorner from "../images/Yellow Line Art People Logo (1).png";
import { useDispatch, useSelector } from "react-redux";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import {
  submitCompleteProfile,
  submitUpdateProfile,
} from "../../Actions/userActions";
import { Link } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import api from "../../utils/api";
import Modal from "@mui/material/Modal";
import InterestGrids from "./InterestGrids";

export const CompleteProfile = ({ isEdit }) => {
  const dispatch = useDispatch();
  const [phoneValue, setPhoneValue] = useState("");
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [userRoleValue, setUserRoleValue] = useState("student");
  const [userIdentityImage, setUserIdentityImage] = useState("");
  const [showInterestCollectionGrid, setShowInterestCollectionGrid] =
    useState(false);
  const handleOpen = () => setShowInterestCollectionGrid(true);
  const handleClose = () => setShowInterestCollectionGrid(false);
  const [userDataForInterestGrid, setUserDataForInterestGrid] = useState({});
  const uploadPhoto = async (e) => {
    console.log("e.target", e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const signResponse = await api.get("/signuploadform");
      const signData = await signResponse.data;
      console.log("sign data", signData);
      // return;
      /****** */
      const data = new FormData();

      data.append("file", files[0]);
      // data.append("upload_preset", "klv1irxe");
      data.append("api_key", signData.apikey);
      data.append("timestamp", signData.timestamp);
      data.append("signature", signData.signature);
      data.append("eager", "c_fill,h_400,w_600");
      // data.append("eager", "c_pad,h_100,w_500|c_crop,h_100,w_500");
      try {
        const res = await fetch(
          "https://api.cloudinary.com/v1_1/" +
            signData.cloudname +
            "/auto/upload",

          {
            method: "POST",
            body: data,
          }
        );
        const file = await res.json();
        console.log("response from cloudinary>>>", file);
        // setImage(file?.eager[0]?.secure_url);
        setUserIdentityImage(file?.secure_url);

        let e2 = { target: { name: "image", value: file.secure_url } };
      } catch (err) {
        console.log("error while uploading images", err);
      }
    }
  };
  /******** */
  useEffect(() => {
    if (isEdit) {
      api
        .get(`/user/getUserdataById/${currentUser?.id}`)
        .then((res) => {
          let { data } = res;
          console.log("jdjsnfvndfnbjnbgonfzdb", data);
          setData({
            userRole: data?.userRole,
            gender: data?.gender,
            userIdentityFile: data?.userIdentityFile,
            phone: data?.phone,
            address: data?.address,
            name: data?.name,
          });
          setPhoneValue(data?.phone);
          setUserRoleValue(data?.userRole);
          setUserIdentityImage(data?.userIdentityFile);
        })
        .catch((err) => console.log(err));
    }
  }, [currentUser, isEdit]);

  /*********** */
  useEffect(() => {
    console.log("current user>>>", currentUser);
  }, [currentUser]);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    userRole: "",
    gender: "",
    userIdentityFile: "",
    phone: "",
    address: "",
  });
  const onChange = (e) => {
    const updatedData = Object.assign(data, {
      [e.target.name]: e.target.value,
    });
    setData(updatedData);
    if (
      e.target.name !== "phone" &&
      e.target.name !== "userRole" &&
      e.target.name !== "userIdentityFile"
    ) {
      document.getElementById(e.target.name).value = e.target?.value;
    }
  };
  useEffect(() => {
    let e = {
      target: {
        name: "phone",
        value: phoneValue,
      },
    };
    onChange(e);
  }, [phoneValue]);
  useEffect(() => {
    let e = {
      target: {
        name: "userRole",
        value: userRoleValue,
      },
    };
    onChange(e);
  }, [userRoleValue]);
  useEffect(() => {
    let e = {
      target: {
        name: "userIdentityFile",
        value: userIdentityImage,
      },
    };
    onChange(e);
  }, [userIdentityImage]);

  const submitData = () => {
    let errs = {};

    if (!data.phone) {
      errs.phone = "phone is required";
    }
    if (!data.address) {
      errs.address = "address is required";
    }
    // if (!data.university) {
    //   errs.university = "university name is required";
    // } else if (!onlyLettersAndSpaces(data.university)) {
    //   errs.university = "enter appropriate university name";
    // }
    if (!data.gender) {
      errs.gender = "gender is required";
    } else if (
      data.gender.toLocaleLowerCase() != "male" &&
      data.gender.toLocaleLowerCase() != "female" &&
      data.gender
    ) {
      errs.gender = "Enter appropriate gender e.g. Male or Female";
    }
    if (!data.userRole) {
      errs.userRole = "required";
    }
    if (!data.userIdentityFile) {
      errs.userIdentityFile = "required";
    }
    setErrors(errs);
    console.log("errors>>>", errs);
    console.log("data>>", data);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      console.log("signup errors while dispatching,", errors);

      let userData;

      userData = {
        userId: currentUser.id,
        name: currentUser?.name,
        userRole: data.userRole.toLocaleLowerCase(),
        gender: data.gender.toLocaleLowerCase(),
        userIdentityFile: data.userIdentityFile,
        phone: data.phone,
        address: data.address,
      };
      if (!isEdit) {
        dispatch(submitCompleteProfile(userData, navigate));
        // setUserDataForInterestGrid(userData);
        // setShowInterestCollectionGrid(true);
      } else {
        dispatch(submitUpdateProfile(userData, navigate));
      }
    }
  };

  return (
    <>
      {/* <Modal
        open={showInterestCollectionGrid}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <InterestGrids
          userData={userDataForInterestGrid}
          setShowInterestCollectionGrid={setShowInterestCollectionGrid}
        />
      </Modal> */}

      <Box className="container-fluid p-0 row">
        {/* <Box className="sidebar-login col-lg-3 d-lg-inline d-none"></Box> */}
        <Box
          className=" col-md-6 col-12"
          sx={{ marginLeft: "50%", transform: "translateX(-50%)" }}
        >
          <Box className="col-2 m-auto">
            <img src={alumnisocialcorner} alt="logo" />
          </Box>
          <Box className="login-title col-12 mt-2">
            <h3 className="text-center">
              {isEdit ? "Edit Your Profile" : "Almost Complete!"}
            </h3>
          </Box>
          <Box>
            <Box className="container form">
              <Box
                className=""
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div className="input-field">
                  <span sx={{ width: "1px" }}></span>
                  <span style={{ marginLeft: "-50px" }}>
                    <PhoneInput
                      placeholder="Enter phone number"
                      // className="text-feild firstdiv_of_projects"
                      className="my-3 w-full bg-gray-100 bg-opacity-50 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={phoneValue}
                      onChange={(value) => setPhoneValue(value)}
                    />
                  </span>
                </div>
                {errors.phone && (
                  <h6 className="signup__error__message">{errors.phone}</h6>
                )}
                <div className="input-field">
                  <i className="fas fa-home"></i>
                  <input
                    type="text"
                    placeholder="Address"
                    id="address"
                    name="address"
                    required
                    defaultValue={data?.address}
                    onChange={(e) => onChange(e)}
                  />
                </div>
                {errors.address && (
                  <h6 className="signup__error__message">{errors.address}</h6>
                )}
                {/* <div className="radio-field-box">
                  <label> choose status</label>
                  <div>
                    {" "}
                    <div className="ml-10">
                      <input
                        type="radio"
                        name="status"
                        onClick={(e) => {
                          let event = {
                            target: {
                              name: "status",
                              value: "student",
                            },
                          };
                          onChange(event);
                        }}
                      />
                      <label className="ml-2 text-sm">Student</label>
                    </div>
                    <div className="ml-12">
                      <input
                        type="radio"
                        name="status"
                        onClick={(e) => {
                          let event = {
                            target: {
                              name: "status",
                              value: "alumni",
                            },
                          };
                          onChange(event);
                        }}
                      />
                      <label className="ml-2 text-sm">Alumni</label>
                    </div>
                  </div>
                </div>
                {errors.status && (
                  <h6 className="signup__error__message">{errors.status}</h6>
                )}
                <div className="radio-field-box">
                  <label> choose one</label>
                  <div>
                    {" "}
                    <div className="ml-10">
                      <input
                        type="radio"
                        name="current"
                        onClick={(e) => {
                          let event = {
                            target: {
                              name: "university",
                              value: "university",
                            },
                          };
                          onChange(event);
                        }}
                      />
                      <label className="ml-2 text-sm">University</label>
                    </div>
                    <div className="ml-12">
                      <input
                        type="radio"
                        name="current"
                        onClick={(e) => {
                          let event = {
                            target: {
                              name: "university",
                              value: "Company",
                            },
                          };
                          onChange(event);
                        }}
                      />
                      <label className="ml-2 text-sm">Company</label>
                    </div>
                  </div>
                </div>
                {errors.university && (
                  <h6 className="signup__error__message">
                    {errors.university}
                  </h6>
                )} */}
                <div className="radio-field-box">
                  <label> Gender</label>
                  <div>
                    {" "}
                    <div className="ml-10">
                      <input
                        type="radio"
                        defaultChecked={data?.gender == "male"}
                        name="gender"
                        onClick={(e) => {
                          let event = {
                            target: {
                              name: "gender",
                              value: "male",
                            },
                          };
                          onChange(event);
                        }}
                      />
                      <label className="ml-2 text-sm">Male</label>
                    </div>
                    <div className="ml-12">
                      <input
                        type="radio"
                        name="gender"
                        onClick={(e) => {
                          let event = {
                            target: {
                              name: "gender",
                              value: "female",
                            },
                          };
                          onChange(event);
                        }}
                        defaultChecked={data?.gender == "female"}
                      />
                      <label className="ml-2 text-sm">Female</label>
                    </div>
                  </div>
                </div>
                {errors.gender && (
                  <h6 className="signup__error__message">{errors.gender}</h6>
                )}
                {!isEdit && (
                  <>
                    <div className="radio-field-box">
                      {/* <i className="fas fa-home"></i> */}
                      {/* <input
                  type="text"
                  placeholder="Address"
                  id="address"
                  name="address"
                  required
                  onChange={(e) => onChange(e)}
                /> */}
                      <label> Choose your role</label>
                      <div>
                        <select
                          style={{
                            width: "300px",
                            padding: "15px",
                            background: "transparent",
                            fontSize: "0.875rem",
                            color: "#AAAAAA",
                            fontWeight: "500",
                          }}
                          onChange={(e) => setUserRoleValue(e.target.value)}
                          defaultValue={userRoleValue}
                        >
                          {/* <option>N/A</option> */}
                          <option value="student">Student</option>
                          <option value="alumni"> Alumni</option>
                          <option value="fypSupervisor">FYP Supervisor</option>
                          <option value="hostelOwner">Hostel Owner</option>
                          <option value="companyRepresentative">
                            Company representative
                          </option>
                          <option value="sscOfficer">SSC Officer</option>
                        </select>
                      </div>
                    </div>
                    {errors?.userRole && (
                      <h6 className="signup__error__message">
                        {errors?.userRole}
                      </h6>
                    )}
                  </>
                )}
                {true && (
                  <>
                    {" "}
                    <div className="radio-field-box">
                      {/* <i className="fas fa-home"></i> */}
                      {/* <input
                  type="text"
                  placeholder="Address"
                  id="address"
                  name="address"
                  required
                  onChange={(e) => onChange(e)}
                /> */}
                      <label>
                        please upload your{" "}
                        {userRoleValue == "student" || userRoleValue == "alumni"
                          ? "Student Card"
                          : userRoleValue == "hostelOwner"
                          ? "CNIC"
                          : userRoleValue == "fypSupervisor"
                          ? "Faculty Card"
                          : userRoleValue == "sscOfficer"
                          ? "Staff Card"
                          : "Employee Card"}
                      </label>
                      <label>(scanned image)</label>
                      <div style={{ padding: "0 20px" }}>
                        <input type="file" onChange={(e) => uploadPhoto(e)} />
                      </div>
                    </div>
                    {userIdentityImage && (
                      <img
                        src={userIdentityImage}
                        style={{ height: "100px", width: "auto" }}
                      />
                    )}
                    {errors?.userIdentityFile && (
                      <h6 className="signup__error__message">
                        {errors?.userIdentityFile}
                      </h6>
                    )}
                  </>
                )}

                <Box className="mt-3">
                  {isEdit ? (
                    <button
                      className="asc__submit__form__button"
                      onClick={() => submitData()}
                      style={{ marginBottom: "30px" }}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      className="asc__submit__form__button"
                      onClick={() => submitData()}
                      style={{ marginBottom: "30px" }}
                    >
                      Submit
                    </button>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
var validator = require("email-validator");
const validateEmail = (email) => {
  console.log("validating email>>>> ", email);
  let test;
  let length = email.length;
  let demail = email.slice(length - 4, length);
  console.log("demail>>>", demail);
  if (demail !== ".com") {
    return false;
  }
  let count = 0;
  let email2 = email.slice(0, length - 4);
  if (email2.includes(".com")) {
    return false;
  }
  if (
    !email.includes("@gmail.com") &&
    !email.includes("@yahoo.com") &&
    !email.includes("@hotmail.com") &&
    !email.includes("@outlook.com")
  ) {
    return false;
  }
  if (!validator.validate(email)) {
    return false;
  }
  return true;
};
function onlyLettersAndSpaces(str) {
  return /^[A-Za-z\s]*$/.test(str);
}
